<template>
  <v-app-bar id="core-app-bar" app color="white" elevate-on-scroll height="96">
    <v-container>
      <v-row>
        <div class="d-flex align-center">
          <a href="/">
            <v-img
              src="../../assets/logo3.svg"
              contain
              height="96"
              width="250"
            />
          </a>
        </div>

        <v-spacer />

        <v-toolbar-items v-if="$vuetify.breakpoint.smAndUp" class="shrink">
          <v-btn
            active-class="primary--text"
            class="subtitle-3 ml-1"
            exact
            min-width="128"
            text
            @click="onClickEmail"
          >
            <v-icon class="pr-3" color="primary">
              mdi-email-edit-outline
            </v-icon>
            <span class="d-none d-md-block">Написать</span>
          </v-btn>
          <v-btn
            active-class="primary--text"
            class="subtitle-3 ml-1"
            exact
            min-width="128"
            text
          >
            <v-icon class="pr-3" color="primary">
              mdi-phone
            </v-icon>
            <span @click="onClickTel">+7 (999) 555-52-28</span>
          </v-btn>
          <v-btn
            color="primary"
            class="mt-0"
            icon
            href="https://wa.me/79995555228"
          >
            <v-icon>mdi-whatsapp</v-icon>
          </v-btn>
          <v-btn
            color="primary"
            class="mt-0"
            icon
            href="https://www.instagram.com/5tu.ru/"
          >
            <v-icon>mdi-instagram</v-icon>
          </v-btn>
        </v-toolbar-items>

        <v-app-bar-nav-icon
          color="primary"
          class="mt-6"
          v-else
          @click="setDrawer(true)"
        />
      </v-row>
    </v-container>
  </v-app-bar>
</template>

<script>
// Utilities
import { mapMutations } from "vuex";
export default {
  name: "CoreAppBar",
  methods: {
    ...mapMutations({
      setDrawer: "setDrawer"
    }),
    onClickTel() {
      window.open("tel:+79995555228", "_blank");
    },
    onClickEmail() {
      window.open("mailto:zakaz-5tu.ru@yandex.ru", "_blank");
    }
  }
};
</script>
